import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#FFF5F0] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-80">
      <div className="mx-auto max-w-3xl" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative rounded-3xl bg-white p-10 sm:p-16 text-center shadow-2xl ring-1 ring-black/5" data-id="element-82">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 rounded-full bg-[#D4603A] p-4 shadow-lg" data-id="element-83">
            <ShieldCheckIcon className="h-8 w-8 text-white" data-id="element-84" />
          </div>

          <h2 className="mb-6 mt-4 font-serif text-3xl font-bold text-[#2D2D2D] sm:text-4xl" data-id="element-85">
            Here's my promise to you:
          </h2>

          <div className="space-y-6 font-sans text-lg leading-relaxed text-[#2D2D2D]/90" data-id="element-86">
            <p data-id="element-87">
              Read this. Implement the first 14 days. Do the breathing work.
              Follow the Holy Plate for one week. Do the 12-minute activation
              three times.
            </p>
            <p className="font-bold text-[#D4603A]" data-id="element-88">
              If you don't feel a measurable shift in your energy, your posture,
              your core stability, and your sense of self — I don't deserve your
              trust or your investment.
            </p>
            <p data-id="element-89">
              This system was built in the real world. On broken sleep. With a
              baby on the hip. If it didn't work in those conditions, it
              wouldn't exist.
            </p>
            <p className="font-serif text-2xl italic text-[#2D2D2D] pt-4" data-id="element-90">
              It works. But only if you show up for yourself — even imperfectly.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}